module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0053.jpg?v=6c06ec1c";